export default __webpack_public_path__ + "static/media/success.67f3251c.png";